<app-pagetoolbar icon="timeline" label="Cycle Timeline"> </app-pagetoolbar>
<div class="container">
  <button *ngIf="previousPeriod" class="nav-button left" (click)="navigateTo(previousPeriod.matchingPeriodName)">
    <mat-icon>keyboard_arrow_left</mat-icon>
    {{ previousPeriod.matchingPeriodName || "--" }}
  </button>

  <div class="current-cycle">{{ currentPeriod?.matchingPeriodName }}</div>

  <button *ngIf="nextPeriod" class="nav-button right" (click)="navigateTo(nextPeriod.matchingPeriodName)">
    {{ nextPeriod.matchingPeriodName }}
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>

<app-timeline-ul>
  <app-timeline-entry [compactTimelineEntrys]="compactTimelines" [currentMatchingPeriod]="currentPeriod" [nextMatchingPeriod]="nextPeriod"> </app-timeline-entry>
</app-timeline-ul>

<button id="scrollup" [ngClass]="scrollUpClass()" (click)="scrollToFirstItem()" class="mat-elevation-z6">
  <mat-icon>publish</mat-icon>
</button>
<button id="scrolldown" [ngClass]="scrollDownClass()" (click)="scrollToLastItem()" class="mat-elevation-z6">
  <mat-icon>publish</mat-icon>
</button>
